(function ($) {
  Drupal.behaviors.shadeImageCarouselBlockFormatter = {
    attach: function (context, settings) {
      var isMobile = Unison.fetch.now().name === 'small';
      var $formatters = $('.js-shade-image-carousel-block__shadelink', context);
      var formatter = {};

      $formatters.each(function (i, obj) {
        formatter = $(obj);
        // Setup the sku links to use shade routing
        var $skuLinks = $('.js-product-sku-link', formatter);

        $skuLinks.each(function (i, sku) {
          var $link = $(sku);
          var skuBaseId = $link.data('sku-base-id');

          if (!skuBaseId) {
            return;
          }

          var skuObject = prodcat.data.getSku(skuBaseId);

          // Support both direct sku payloads and payloads nested under "data"
          var skuData = skuObject;

          if (skuObject && typeof skuObject === 'object' && skuObject.data && typeof skuObject.data === 'object') {
            skuData = skuObject.data;
          }

          if (skuData && typeof skuData === 'object' && skuData.PRODUCT_ID) {
            var product = prodcat.data.getProduct(skuData.PRODUCT_ID);
            var shadeRouteName = prodcat.ui.generateShadePath(skuBaseId);
            var $addToBag = $('.js-add-to-cart', formatter);

            // Lets check SKU inventory status if CTA are displayed
            if ($addToBag.length) {
              switch (skuData.INVENTORY_STATUS) {
                case 2:
                  $addToBag.hide();
                  $('.js-inv-status-2', formatter).removeClass('hidden');
                  break;
                case 3:
                  $addToBag.hide();
                  $('.js-inv-status-3', formatter).removeClass('hidden');
                  break;
                case 5:
                  $addToBag.hide();
                  $('.js-inv-status-5', formatter).removeClass('hidden');
                  break;
                case 7:
                  $addToBag.hide();
                  $('.js-inv-status-7', formatter).removeClass('hidden');
                  break;
              }
            }
            if (!_.isEmpty(shadeRouteName) && product && typeof product === 'object' && product.url) {
              $link.each(function (i, aTag) {
                aTag.href = product.url + shadeRouteName;
              });
            }
          } else {
            return;
          }
        });
      });

      var $selectFilter = $('.js-shade-image-carousel-block__shade-filters', context).find('select');

      $('.js-basic-carousel__slide[data-tabgroup]').each(function () {
        if (!$('.js-product-group-tab[data-tab="' + $(this).data('tabgroup') + '"]').html()) {
          if (!isMobile) {
            $('.js-product-group-tabs').append(
              '<a href="#" role="button" class="js-product-group-tab shade-image-carousel-block__filter" data-tab="' + $(this).data('tabgroup') + '">' + $(this).data('tabgroup') + '</a>'
            );
          } else {
          // and for mobile update the select
            var $option = this;
            var newOption = 1;

            if ($($selectFilter).find('option')) {
              $($selectFilter).find('option').each(function (i, v) {
                if ($($option).data('tabgroup') === v.value) {
                  newOption = 0;

                  return;
                }
              });
            }
            if (newOption) {
              $($selectFilter).append($('<option>', {
                value: $($option).data('tabgroup'),
                text: $($option).data('tabgroup')
              }));
            }
          }
        }
      });

      // hook up for filter click
      $($selectFilter).on('change', $selectFilter, function (ev) {
        ev.preventDefault();
        if (this.selectedIndex !== 0) {
          $('.js-basic-carousel-shade').slickFilter('*[data-tabgroup="' + $(this).val() + '"]');
        } else {
          $('.js-basic-carousel-shade').slickUnfilter();
        }
        if ($(this.parentElement).find('[data-tabgroup]').length) {
          $(this.parentElement).find('[data-tabgroup]').removeClass('active');
        }
        if ($(this.parentElement).find("[data-tabgroup='" + $(this).val() + "']").length) {
          $(this.parentElement).find("[data-tabgroup='" + $(this).val() + "']").addClass('active');
        }
      });

      $('.js-product-group-tabs').on('click', '.js-product-group-tab', function (ev) {
        ev.preventDefault();
        $('.js-basic-carousel-shade').slickUnfilter();
        if ($(this).data('tab') !== 0) {
          $('.js-basic-carousel-shade').slickFilter('*[data-tabgroup="' + $(this).data('tab') + '"]');
        }
        $('.js-product-group-tab').removeClass('active');
        $(this).addClass('active');
      });

      $('.js-basic-carousel-shade').each(function () {
        // Init this carousel with our settings
        $(this).slick(getSliderSettings($(this), isMobile));
      });

      function getSliderSettings(slickObject, isMobile) {
        var slickParent = slickObject.parent();
        var $arrowsPrev = slickParent.find('.slick-prev');
        var $arrowsNext = slickParent.find('.slick-next');

        return {
          prevArrow: $arrowsPrev,
          nextArrow: $arrowsNext,
          autoplay: false,
          infinite: true,
          slidesToShow: isMobile ? 1 : 5,
          slidesToScroll: isMobile ? 1 : 2
        };
      }
    }

  };
})(jQuery);
